import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getChargeDetails } from "../../actions/commonActions";
import moment from "moment";
import { setPageTitle } from "../../utils/helper";
import "./styles.css"

const MOMENT_FORMAT = "YYYY-MM-DD HH:mm A";
const MOMENT_FORMAT_MONTH = "MMMM";
const MOMENT_FORMAT_YEAR = "YYYY";

const ChargeHistory = () => {

  const [currentMonthYear, setCurrentMonthYear] = useState(null);
  const [goToMonth, setGoToMonth] = useState(null);

  const dispatch = useDispatch();
  const { chargeDetails } = useSelector((reduxState) => reduxState.common);
  const allMonths = ['January', "February", "March", "April", "May", "June", "July", "August", "September", "October"
    , "November", "December"];

  let driverId = localStorage.getItem("driver_id");

  useEffect(() => {
    setGoToMonth(currentMonthYear)
  }, [currentMonthYear])

  useEffect(() => {
    getChargeDetails(dispatch, driverId);
    setPageTitle("Usage Details");
  }, []);

  useEffect(() => {
    let today = new Date();
    let todayMonth = moment(today).format(
      MOMENT_FORMAT_MONTH)
    let todayYear = moment(today).format(
      MOMENT_FORMAT_YEAR)
    setCurrentMonthYear({
      month: todayMonth,
      year: +todayYear
    })
  }, [])
console.log("chargeDetails",chargeDetails)
  // console.log("CHARGE DETAILS CHECK:", { chargeDetails, currentMonthYear, goToMonth })
  // console.log("index of current Month:", allMonths.indexOf(currentMonthYear?.month));

  const nextMonth = () => {
    if (goToMonth.month !== currentMonthYear.month || goToMonth.year !== currentMonthYear.year) {

      let currentIndex = allMonths.indexOf(goToMonth?.month);
      if (goToMonth?.month && goToMonth?.month === "December") {
        setGoToMonth({
          month: allMonths[0],
          year: goToMonth?.year + 1
        })
      } else {
        setGoToMonth({
          month: allMonths[currentIndex + 1],
          year: goToMonth?.year
        })
      }

      // console.log("Next Month is: ", goToMonth)
    }

  };

  const prevMonth = () => {

    let currentIndex = allMonths.indexOf(goToMonth?.month);
    if (goToMonth?.month && goToMonth?.month === "January") {
      setGoToMonth({
        month: allMonths[allMonths.length - 1],
        year: goToMonth?.year - 1
      })
    } else {
      setGoToMonth({
        month: allMonths[currentIndex - 1],
        year: goToMonth?.year
      })
    }

  };

  // const filterDataArray = [
  //   { key: 1, name: "Today" },
  //   { key: 7, name: "7 Days" },
  //   { key: 30, name: "30 Days" },
  //   { key: 90, name: "90 Days" },
  //   { key: 'all', name: "All" }
  // ]

  // const onChangeFilter = (e) => {
  //   const { value } = e.target;
  //   console.log("Change", value)
  //   getChargeDetails(dispatch, driverId);
  // }

  return (
    <div>
      <div className="text-center mt-3">
        <h3>Usage Details</h3>
        <div className="active-charging-site p-3 date_main">
          <div className="month_year_main">

            <span onClick={() => prevMonth()} className="arrow_prev fa fa-arrow-left" aria-hidden="true" >  </span>

            <div>
              {goToMonth?.month}
            </div>
            <div>
              {goToMonth?.year}
            </div>

            <span onClick={() => nextMonth()} className={`arrow_next fa fa-arrow-right ${goToMonth?.month === currentMonthYear?.month && goToMonth?.year === currentMonthYear?.year ? "disable" : null}`} aria-hidden="true" >  </span>

          </div>

          {/* <select className="custom-select" onChange={onChangeFilter}>
            {
              filterDataArray.map((filter, i) => (
                <option key={i} value={filter.key}>
                  {filter.name}
                </option>
              ))
            }
          </select> */}
        </div>
        {chargeDetails.length > 0 ? (
          <table className="table mt-3 table-striped ">
            {/* <thead>
              <tr>
                <th>Start</th>
                <th>Stop</th>
                <th>kWh</th>
              </tr>
            </thead> */}
            <tbody>
              {
                chargeDetails.filter((payment) => {

                  if (moment(payment.start_event_timestamp).format(MOMENT_FORMAT_MONTH) === goToMonth?.month && moment(payment.start_event_timestamp).format(MOMENT_FORMAT_YEAR) == goToMonth?.year) {
                    return payment
                  }
                }).length > 0 ?


                  (chargeDetails.filter((payment) => {

                    if (moment(payment.start_event_timestamp).format(MOMENT_FORMAT_MONTH) === goToMonth?.month && moment(payment.start_event_timestamp).format(MOMENT_FORMAT_YEAR) == goToMonth?.year) {
                      return payment
                    }
                  }

                  ).map((payment, i) => (
                    <tr key={i}>
                      <td className="usage_detail_main">
                        <div className="udm_text">
                          <p className="time start_time">

                            {payment.start_event_timestamp &&
                              moment(payment.start_event_timestamp).format(
                                MOMENT_FORMAT
                              )}
                          </p>
                          <p className="time end_time">
                            {payment.stop_event_timestamp &&
                              moment(payment.stop_event_timestamp).format(
                                MOMENT_FORMAT
                              )}
                          </p>
                        </div>
                        <div>
                          <p className="udm_consumption">
                            {Math.round(payment.watt_usage * 10) / 10} kWh
                            {/* {payment.watt_usage} */}
                          </p>
                        </div>
                      </td>

                      {/* <td>
                    {payment.stop_event_timestamp &&
                      moment(payment.stop_event_timestamp).format(
                        MOMENT_FORMAT
                      )}
                  </td>

                  <td>
                    {payment.watt_usage}
                    {payment.total_amount}
                    <p>
                      VAT: {payment.currency_code}{" "}
                      {Math.round(payment.vat_amount)}
                    </p>
                  </td> */}
                    </tr>
                  ))) : (<tr>
                    <td>

                      <div>

                        No Charge History Found for This Month
                      </div>


                    </td>
                  </tr>)
              }
            </tbody>
          </table>
        ) : (
          <p className="no-history">No Charge history</p>
        )}
      </div>
    </div>
  );
};

export default ChargeHistory;
